import { render, staticRenderFns } from "./PreferencesAddNewComponent.vue?vue&type=template&id=0789951d&scoped=true"
import script from "./PreferencesAddNewComponent.vue?vue&type=script&lang=js"
export * from "./PreferencesAddNewComponent.vue?vue&type=script&lang=js"
import style0 from "./PreferencesAddNewComponent.vue?vue&type=style&index=0&id=0789951d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0789951d",
  null
  
)

export default component.exports